module.exports = __webpack_public_path__ + "img/sv33.aa917953.svg";